<template>
  <div class= "compras-abm-percepciones">
    <b-card no-header>
      <b-form>
        <!-- <div v-for="percepcionGrupo in percepciones" :key= "percepcionGrupo.id"> -->
        <div v-for="percepcion in percepciones" :key= "percepcion.id">
          <b-form-group
            :label="percepcion.jurisdiccion"
            label-for="percepcion.jurisdiccion"
            :label-cols="4"
            horizontal>
            <b-form-input 
              id="percepcion.jurisdiccion"
              class="base"
              v-model.trim="percepcion.importe"
              type="number" 
              step="0.01"
              :state="percepcion.state"
              @blur.native="validate(percepcion)">
            </b-form-input>
            <b-form-invalid-feedback>
              {{ percepcion.msjInvalido }}
            </b-form-invalid-feedback>          
          </b-form-group>
        </div>
      </b-form>

      <b-alert
        class="alert"
        :show="dismissCountDown"
        dismissible
        fade
        :variant="alertVariant"
        @dismissed="dismissCountDown = 0"
        @dismiss-count-down="countDownChanged">
        <p>{{ alertMsj }}</p>
      </b-alert>             

      <div slot="footer">
        <b-button size="sm" variant="primary" class="footer-button"
          @click.prevent="save">Grabar</b-button>
        <b-button size="sm" variant="danger" class="footer-button"
          @click.prevent="goBack">Cancelar</b-button>
      </div>
    </b-card>

    <b-modal ref="searchJurisdiccionModal" 
        title="Seleccionar Jurisdiccion"
        header-bg-variant="light" 
        hide-footer
        lazy
        modal-class="search-modal">
      <app-search-jurisdiccion
        @jurisdiccionSeleccionada="jurisdiccionSeleccionada">
      </app-search-jurisdiccion>  
    </b-modal>
  </div>
</template>

<script>
import SearchJurisdiccion from '../jurisdiccionesIngresosBrutos/SearchList.vue';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'comprapercepcionesprovinciales/getField',
  mutationType: 'comprapercepcionesprovinciales/updateField',
});

export default {
  name: 'ComprasPercepciones',
  components: {
    appSearchJurisdiccion: SearchJurisdiccion,
  },
  data () {
    return {
      alertCountDown: 10, 
      dismissCountDown: 0,
      alertVariant: 'danger',
      alertMsj: '',
    }
  },
  computed: {
    ...mapFields([
      'percepciones',
    ]),
  },
  created() {
    //this.$store.dispatch('comprapercepcionesprovinciales/inicializar', this.percepciones);
  },  
  methods: {
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert() {
      this.dismissCountDown = this.alertCountDown;
    },
    validate(percepcion) {
      percepcion.state = null;
      percepcion.msjInvalido = '';
    },
    save () {
      let save = true;

      this.percepciones.forEach(percepcion => {
        if (percepcion.importe == '') {
          percepcion.importe = 0;
        } else if (isNaN(percepcion.importe)) {
          percepcion.state = false;
          percepcion.msjInvalido = 'Verifique el importe ingresado';
          save = false;
        }
      });
      
      if (save) {
        this.$store.dispatch('comprapercepcionesprovinciales/save')
          .then(() => {
            this.$emit('updatePercepcionesProvinciales');
          })
          .catch( error => {
            this.alertMsj = error;
            this.alertVariant = "danger";
            this.alertCountDown = 15;
            this.showAlert();              
          })
          .finally(() => {
            this.hideSpinner();
          })
      }
    },
    goBack() {
      this.$emit('closePercepcionesProvinciales');
    },
    agregar() {
      this.$refs.searchJurisdiccionModal.show();
    },
    jurisdiccionSeleccionada(item) {
      this.$refs.searchJurisdiccionModal.hide();
      this.$store.dispatch('comprapercepcionesprovinciales/agregarJurisdiccion', item);
    }
  },
}
</script>

<style>
</style>
